/**
 * Utilitaires pour la gestion des JWT
 */

export interface JwtPayload {
  sub: string;
  email: string;
  iat: number;
  exp: number;
}

/**
 * Décode un JWT sans vérifier la signature (côté client uniquement)
 */
export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    const payload = JSON.parse(atob(parts[1]));
    return payload;
  } catch {
    return null;
  }
}

/**
 * Vérifie si un JWT est expiré
 */
export function isJwtExpired(token: string): boolean {
  const payload = decodeJwt(token);
  if (!payload) return true;
  
  const now = Math.floor(Date.now() / 1000);
  return payload.exp < now;
}

/**
 * Vérifie si un JWT expire dans les N secondes
 */
export function isJwtExpiringSoon(token: string, thresholdSeconds: number = 300): boolean {
  const payload = decodeJwt(token);
  if (!payload) return true;
  
  const now = Math.floor(Date.now() / 1000);
  return payload.exp < (now + thresholdSeconds);
}

/**
 * Obtient le temps restant avant expiration en secondes
 */
export function getJwtRemainingTime(token: string): number {
  const payload = decodeJwt(token);
  if (!payload) return 0;
  
  const now = Math.floor(Date.now() / 1000);
  return Math.max(0, payload.exp - now);
}